define('loader',[
    'edap',
    'debughelpers',
    'ua/edap-ua-integration',
    'hadoop/edap-hadoop-integration',
    'tagmanager/edap-tagmanager-integration',
    'personalization/edap-personalization-integration',
    'demo/edap-demo-integration',
    'proctor/edap-proctor-integration',
    'init'
], function(inittedEdap, debugHelpers, ua, hadoop, tagmanager, personalization, demo, proctor, integrations) {
    'use strict';

    var verboseDebugName = 'logloadevents',
        loadEvents = [
            'ua.load',
            'ua.did.load',
            'tagmanager.load',
            'tagmanager.did.load',
            'proctor.load',
            'proctor.did.load'
        ];

    // If we are not in debug mode then we will need to add the load/did.load events to the ignore console events
    if (!debugHelpers.isInDebugMode(verboseDebugName)) {
        inittedEdap['public'].ignoredConsoleEvents = inittedEdap['public'].ignoredConsoleEvents.concat(loadEvents);
    }

    ua.init();
    hadoop.init();
    tagmanager.init();
    personalization.init();
    demo.init();
    proctor.init();

    // this one should always be last to make sure all other integrations have registered their callbacks
    integrations.init();

    return inittedEdap;
});

